import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import VisionMission from './pages/VisionMission';
import Events from './pages/Events';
import Scholarship from './pages/Scholarship';
import Women from './pages/Women';
import Reyocc from './pages/Reyocc';
import VisionRefocc from './pages/VisionRefocc';
import Gallery from './pages/Gallery';
import Contact from './pages/Contact';

import { Toaster } from './components/ui/toaster';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App bg-refocc-cream min-h-screen">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/vision-mission" element={<VisionMission />} />
            <Route path="/events" element={<Events />} />
            <Route path="/scholarship" element={<Scholarship />} />
            <Route path="/women" element={<Women />} />
            <Route path="/reyocc" element={<Reyocc />} />
            <Route path="/vision-refocc" element={<VisionRefocc />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/contact" element={<Contact />} />

            <Route path="*" element={<Home />} />
          </Routes>
        </main>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
